
import { useMsal } from "@azure/msal-react"
import React, { useEffect, useState } from "react"

import { loginRequest } from "./authConfig"
import { USER_LOGIN_SESSIONID } from "./Configuration";
import { generateGUID } from "./shared/utils/globalFunctions";

// Define types for user data

const LoginPage: React.FC = () => {
  const { accounts, instance } = useMsal()
  const [loading, setLoading] = useState<boolean>(true) // Add loading state
  useEffect(() => {
    if (accounts.length === 0) {
      login() 
    } 
  }, [accounts])

   // Handle redirect response after returning from ADFS
   useEffect(() => {
    instance.handleRedirectPromise()
      .then((response) => {
        if (response) console.log("Login Successful", response);
      })
      .catch((error) => {
        console.error("Redirect Error", error);
      });
  }, []);
  
  const login = () => {
    instance.loginRedirect(loginRequest)
      .then((response:any) => {
        const accessToken = response.accessToken  
        localStorage.setItem(USER_LOGIN_SESSIONID,generateGUID()??'');  
        if (accessToken) {
          localStorage.setItem('access_token', accessToken)
        }
      })
      .catch((error) => {
        console.error("Login error", error)
        setLoading(false) 
      })
  }


  return (
    <div>
    </div>
  )
}

export default LoginPage